import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllNotesUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllNotes/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllNotesUser = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllNotesUser;
};


const setActiveNotes = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setNotesActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllNotesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса notes  - ',response);


    return AllNotesUser;
};



const setDeletedNotes = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setNotesDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllNotesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса notes  - ',response);


    return AllNotesUser;
};




const setUpdateNotes = async (dataNotesUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setNotesUpdate/'),{
        dataNotesUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllNotesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса notes  - ',response);


    return AllNotesUser;
};


const setSaveNewNotes = async (dataNotesUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewNotes/'),{
        dataNotesUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllNotesUser = data;

    // console.log('Сервер вернул данные по обновлению статуса notes  - ',response);


    return AllNotesUser;
};

Mock.onGet('/api/reference/getAllNotes').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllNotesUser = await getAllNotesUser();

    // if (!AllNotesUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllNotesUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllNotesUser,
    ]


})


Mock.onPost('/api/reference/setActiveNotes').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllNotesUser = await setActiveNotes(id,val);

    // if (!AllNotesUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllNotesUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllNotesUser,
    ]


})

Mock.onPost('/api/reference/setDeletedNotes').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllNotesUser = await setDeletedNotes(id,val);

    // if (!AllNotesUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllNotesUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllNotesUser,
    ]


})


Mock.onPost('/api/reference/setUpdateNotes').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataNotesUpdate } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ', config.data);

    const refereNotes = await setUpdateNotes(dataNotesUpdate);

    // console.log('Серовер вернул данные ',AllNotesUser);

    // if (!refereNotes) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereNotes) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereNotes,
    ]


})


Mock.onPost('/api/reference/setSaveNewNotes').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataNotesUpdate } = JSON.parse(config.data);
    console.log('Данные для отправки на сервер ', config.data);

    const refereNotes = await setSaveNewNotes(dataNotesUpdate);

    // console.log('Серовер вернул данные ',AllNotesUser);

    // if (!refereNotes) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!refereNotes) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        refereNotes,
    ]


})